import React, { Component } from 'react';
import { Context } from 'context';

import Menu from 'components/menu/Menu';

import styles from 'editor/workspace/window/titlebar/ReportMap.module.scss';

export default class ReportMap extends Component {
    static contextType = Context;
    state = {
        message: ""
    }

    onChange = event => {
        this.setState({message: event.target.value})
    }

    submit = async event => {
        await this.context.reportMapIssue(this.props.id, this.state.message)
        this.setState({message: ""})
    }

    render() {
        return (
            <Menu
                iconSrc={require(`images/icons/report${this.context.lightTheme ? "-light" : "-dark" }.svg`)}
                iconAlt="Report map issue"
                hint={this.context.text.hints.reportMap}
                title="Report map issue"
            >
                <textarea
                    className={styles.textArea}
                    onChange={this.onChange}
                    placeholder="What's wrong with this map?"
                    value={this.state.message}
                >

                </textarea>
                <button className={`btn btnBrand ${styles.submit}`} onClick={this.submit}>Report Map</button>
            </Menu>
        )
    }
}